import { useEffect, useState } from "react";
import { apiGet } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { CheckCircle2, XCircle, Activity, RefreshCw, AlertTriangle } from "lucide-react";

const TYPE_LABEL = { test: "Manual test", health: "Scheduled check", sync: "Data sync" };

export default function EventsDialog({ open, onOpenChange, instance }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !instance) return;
    setLoading(true);
    apiGet(`/connectors/instances/${instance.id}/events`)
      .then((d) => setEvents(d.events || []))
      .finally(() => setLoading(false));
  }, [open, instance]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[560px] max-h-[85vh] overflow-y-auto" data-testid="events-dialog">
        <DialogHeader>
          <DialogTitle className="small-caps flex items-center gap-2">
            <Activity className="w-4 h-4" /> Activity — {instance?.name}
          </DialogTitle>
        </DialogHeader>
        {loading && <div className="text-[13px]" style={{ color: "var(--cv-dark-grey)" }}>Loading…</div>}
        {!loading && events.length === 0 && (
          <div className="text-[13px]" style={{ color: "var(--cv-dark-grey)" }} data-testid="events-empty">No activity recorded yet.</div>
        )}
        <div className="flex flex-col gap-2">
          {events.map((e) => (
            <div key={e.id} className="flex items-start gap-2.5 p-2.5 rounded" data-testid={`event-${e.id}`}
              style={{ border: "1px solid var(--cv-line)", background: e.dropped ? "rgba(165,48,15,.05)" : "#fff" }}>
              {e.ok ? <CheckCircle2 className="w-4 h-4 mt-0.5" style={{ color: "#2F6B41" }} />
                    : <XCircle className="w-4 h-4 mt-0.5" style={{ color: "#A5300F" }} />}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[13px] font-bold" style={{ color: "var(--cv-charcoal)" }}>{TYPE_LABEL[e.type] || e.type}</span>
                  <span className="inline-flex items-center gap-1 text-[10px] font-bold" style={{ color: "var(--cv-dark-grey)" }}>
                    {e.type === "health" ? <RefreshCw className="w-3 h-3" /> : null}
                    {e.http_status ? `HTTP ${e.http_status}` : ""}
                  </span>
                  {e.dropped && (
                    <span className="inline-flex items-center gap-1 text-[10px] font-bold" style={{ background: "rgba(165,48,15,.12)", color: "#A5300F", borderRadius: 999, padding: "1px 7px" }}>
                      <AlertTriangle className="w-2.5 h-2.5" /> Dropped
                    </span>
                  )}
                </div>
                <div className="text-[12px]" style={{ color: "var(--text-secondary)" }}>{e.message}</div>
                <div className="text-[11px]" style={{ color: "var(--text-muted)" }}>{new Date(e.created_at).toLocaleString()}</div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
